import Actions from '../../odata/actions';

const actions = new Actions('issue', 'issues');

export default actions;
